import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "IcsPreview" */ './lazyIndex'));

export const lazyAddToCalendar = new LazyImport(lazyModule, m => m.addToCalendar);
export const lazyGetIcsCalendarItem = new LazyImport(lazyModule, m => m.getIcsCalendarItem);
export const lazyGetIcsCalendarItemOrchestrator = new LazyImport(
    lazyModule,
    m => m.getIcsCalendarItemOrchestrator
);

export {
    default as IcsPreviewState,
    AddToCalendarStatus,
    IcsCalendarEventType,
} from './store/schema/IcsPreviewState';

export const IcsPreview = createLazyComponent(lazyModule, m => m.IcsPreview);
